export enum IconTypes {
  MORE = 'more',
  CREATE = 'create',
  CLEAR = 'clear',
  SEARCH = 'search',
  BACK = 'back',
  EMOJI = 'emoji',
  PROGRESS = 'progress',
  FILE = 'file',
  CLOSE = 'close',
  CANCEL = 'cancel',
  ADD = 'plus',
  IMAGE = 'image',
  VIDEO = 'video',
  DOCUMENT = 'document',
  STAR = 'star',
  COPY = 'copy',
  DEL = 'del',
  FORWARD = 'forward',
  REPLY = 'reply',
  RIGHT = 'right',
  ARROW_RIGHT = 'arrow-right',
  ELLIPSE = 'ellipse',
  ARROW_DOWN = 'arrow-down',
  EDIT = 'edit',
  CONFIRM = 'confirm',
  CAMERA = 'camera',
  QUOTE = 'quote',
  REVOCATION = 'revocation',
  EFFORT = 'effort',
  CRY = 'cry',
  SEND = 'send',
  OWNER = 'owner',
  LIVING = 'living',
  MEMBER = 'member',
  LIKE = 'like',
  UNLIKE = 'unlike',
  LIKED = 'liked',
  UNLIKED = 'unliked',
  UNION = 'union',
  UNUNION = 'ununion',
  VECTOR = 'vector',
  UNVECTOR = 'unvector',
  VOICE = 'voice',
}